<template>
  <div class="main-layouts">
    <Row type="flex" class="breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem to="/">
          <Icon type="ios-home-outline"></Icon>
          {{ $t('global.text4') }}
        </BreadcrumbItem>
        <BreadcrumbItem v-if="!$route.query.form_id">
          {{
            $route.name !== 'approver'
              ? $t($route.name)
              : $t(`approval.${$route.query.type}`)
          }}
        </BreadcrumbItem>
      </Breadcrumb>
    </Row>
    <div class="main-container">
      <div class="main-card">
        <div :class="[tabValue === 'calendar' && 'main-card-leave-tabs']">
          <Tabs :value="tabValue" @on-click="onTabChange">
            <TabPane :label="$t('global.leaveCalendar')" name="calendar" />
            <TabPane :label="$t('vacationDetail.vacation')" name="vacation" />
          </Tabs>
        </div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    tabValue() {
      return this.$route.name === 'global.leaveCalendar'
        ? 'calendar'
        : 'vacation';
    }
  },
  methods: {
    onTabChange(name) {
      this.$router.push({
        name:
          name === 'calendar'
            ? 'global.leaveCalendar'
            : 'vacationDetail.vacation'
      });
    }
  }
};
</script>
<style lang="less" scoped>
.main-layouts {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.main-card {
  padding: 20px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.06),
    0px 1px 3px 1px rgba(0, 0, 0, 0.1);

  &-leave-tabs {
    margin-bottom: 16px;
  }
}

.breadcrumb {
  background: #fff;
  padding: 12px 40px;
  margin-bottom: 15px;

  span {
    font-size: 14px;
    font-weight: 400;
    color: #9099a6;
    line-height: 16px;
    margin: 0 5px;
  }

  .link:hover {
    opacity: 0.49;
    cursor: pointer;
  }

  .active {
    color: #1f2329;
  }
}

.main-head {
  font-size: 24px;
  font-weight: 500;
  color: #646a73;
  line-height: 32px;
  margin-bottom: 15px;
}

.main-container {
  flex: 1;
  margin: 16px 40px;
  display: flex;
  flex-direction: column;

  .main-row {
    flex: 1;
  }
}

/deep/.ivu-tabs {
  &-tab {
    font-size: 14px;
  }

  &-tab-active {
    color: #217d8d !important;
    font-weight: 500 !important;
  }

  &-ink-bar {
    height: 4px;
  }
}
</style>
